module.exports = __webpack_public_path__ + "img/under-maintenance-dark.537dbf0a.svg";